import React from "react";
import styled from "styled-components";

import {
  LazyLoadComponent,
  trackWindowScroll,
} from "react-lazy-load-image-component";

import ruoppaukset1 from "../images/ruoppaukset-1.JPG";
import ruoppaukset2 from "../images/ruoppaukset-2.jpg";
import ruoppaukset3 from "../images/ruoppaukset-3.jpg";
import ruoppaukset4 from "../images/ruoppaukset-4.jpeg";
import ruoppaukset5 from "../images/ruoppaukset-5.jpg";
import ruoppaukset6 from "../images/ruoppaukset-6.jpg";
import ruoppaukset7 from "../images/ruoppaukset-7.jpg";
import ruoppaukset8 from "../images/ruoppaukset-8.jpg";

import tiehoyla1 from "../images/tiehoyla-1.jpg";
import tiehoyla2 from "../images/tiehoyla-2.jpg";
import tiehoyla3 from "../images/tiehoyla-3.jpg";

import kaivinkonetyot from "../images/kaivinkonetyot.JPG";
import kaivinkonetyot2 from "../images/kaivinkonetyot-2.jpg";

import dumpperi from "../images/dumpperi.jpg";
import pitkapuomi from "../images/pitkapuomi.jpg";
import rannankunnostus from "../images/rannan-kunnostus.jpg";

import hiekkapuhallus from "../images/hiekkapuhallus.jpg";
import pohjatyo from "../images/pohjatyot-2.jpg";
import kaapelityot from "../images/kaapelityot.JPG";
import maansiirto from "../images/maansiirto.JPG";
import maisemoinnit from "../images/maisemoinnit.JPG";
import purkutyot from "../images/purkutyot.JPG";
import salaojat from "../images/salaojat.JPG";
import vesirakennus from "../images/vesirakennus.jpg";
import vesiviemarityot from "../images/vesiviemarityot.JPG";
import tietkadut from "../images/tiet-ja-kadut.jpg";

const tiehoyla = {
  title: "Tiehöyläpalvelut",
  images: [
    {
      url: tiehoyla1,
      position: "center",
    },
    {
      url: tiehoyla2,
      position: "center",
    },
    {
      url: tiehoyla3,
      position: "center",
    },
  ],
};

const ruoppaukset = {
  title: "Ruoppaukset",
  images: [
    {
      url: ruoppaukset2,
      position: "center",
    },
    {
      url: ruoppaukset3,
      position: "center",
    },
    {
      url: ruoppaukset4,
      position: "center",
    },
    {
      url: ruoppaukset1,
      position: "center",
    },
    {
      url: ruoppaukset5,
      position: "center",
    },
    {
      url: ruoppaukset6,
      position: "center",
    },
    {
      url: ruoppaukset7,
      position: "center",
    },
    {
      url: ruoppaukset8,
      position: "center",
    },
  ],
};

const kaivinkone = {
  title: "Kaivinkonetyöt",
  images: [
    {
      url: kaivinkonetyot2,
      position: "center",
    },
    {
      url: kaivinkonetyot,
      position: "center",
    },
  ],
};

const multiImageServices = [kaivinkone, tiehoyla, ruoppaukset];

const Page = styled.div`
  max-width: 860px;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  height: 100%;
  align-items: center;
  flex-direction: column;
  width: 100%;
  justify-content: space-around;
`;

const Title = styled.h1`
  color: #171717;
  font-family: "Oswald", sans-serif;
  text-transform: uppercase;
  margin-top: 2em;
  margin-bottom: 0;
  text-align: left;
`;

const ServiceCard = styled.div`
  min-width: 320px;
  box-shadow: rgba(0, 0, 0, 0.12) 0px 1px 3px, rgba(0, 0, 0, 0.24) 0px 1px 2px;
  flex: 1;
  flex-flow: row wrap;

  @media only screen and (max-width: 600px) {
    width: 400px;
    min-width: 280px;
  }
`;

const MultiServiceImageWrapper = styled.div`
  width: 370px;
  min-width: 300px;
  box-shadow: rgba(0, 0, 0, 0.12) 0px 1px 3px, rgba(0, 0, 0, 0.24) 0px 1px 2px;
  flex-grow: 1;
`;

const ServiceImage = styled.div`
  min-height: 300px;
  background-repeat: no-repeat;
  background-size: cover;

  background-image: url(${(props) => props.url});
  background-position: ${(props) => props.position};
  flex-grow: 0.5;
`;

const MultiServiceImage = styled(ServiceImage)``;

const ServiceTextWrap = styled.div`
  background-color: #171717;
  display: flex;
  justify-content: center;
  padding: 1em;
  color: white;
`;

const ServiceText = styled.span`
  color: #fafafa;
  font-weight: 600;
  font-family: "Oswald" sans-serif;
  text-transform: uppercase;
  @media only screen and (max-width: 600px) {
    font-size: 1.2em;
  }
`;

const Content = styled.div`
  margin: 0 2rem;
`;

const ContentText = styled.p`
  font-size: 1.2em;
  color: #171717;
  text-align: left;

  @media only screen and (max-width: 600px) {
    margin-top: 2em;
  }
`;

const ServiceGrid = styled.div`
  display: flex;
  flex-wrap: wrap;
  flex-grow: 0.5;

  && {
    > * {
      margin: 0 1rem 1rem 0;
    }

    > :nth-child(3) {
      margin: 0 1rem 0 0;
    }
  }
`;

const Heading = styled.div`
  margin-bottom: 2rem;
  max-width: 1000px;
`;

const services = [
  {
    image: {
      url: maansiirto,
      position: "bottom",
    },
    text: "Maa- ja vesirakennustyöt",
  },
  {
    image: {
      url: hiekkapuhallus,
      position: "bottom",
    },
    text: "Hiekkapuhallus ja maalaus",
  },
  {
    image: {
      url: rannankunnostus,
      position: "bottom",
    },
    text: "Rannan kunnostus",
  },
  {
    image: {
      url: pitkapuomi,
      position: "center",
    },
    text: "Pitkäpuomityöt",
  },
  {
    image: {
      url: pohjatyo,
      position: "center",
    },
    text: "Rakennusten pohjatyöt",
  },
  {
    image: {
      url: tietkadut,
      position: "center",
    },
    text: "Tiet ja kadut",
  },
  {
    image: {
      url: kaapelityot,
      position: "center",
    },
    text: "Kaapeloinnit",
  },
  {
    image: {
      url: maisemoinnit,
      position: "center",
    },
    text: "Maisemoinnit",
  },
  {
    image: {
      url: purkutyot,
      position: "center",
    },
    text: "Purkutyöt",
  },
  {
    image: {
      url: salaojat,
      position: "center",
    },
    text: "Salaojat",
  },
  {
    image: {
      url: vesirakennus,
      position: "center",
    },
    text: "Vesirakennus",
  },
  {
    image: {
      url: vesiviemarityot,
      position: "center",
    },
    text: "Vesi- ja viemärityöt",
  },
  {
    image: {
      url: dumpperi,
      position: "center",
    },
    text: "Maansiirto- ja dumpperityöt",
  },
];

const ServiceTitle = styled.h3`
  font-family: "Oswald", sans-serif;
  font-weight: 600;
  font-size: 1.25rem;
  text-transform: uppercase;
`;

const MultiImageServiceWrapper = styled.div`
  margin-bottom: 3rem;

  @media only screen and (max-width: 600px) {
    min-width: 280px;
    width: 100%;
  }
`;

const ImageWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;

  @media only screen and (max-width: 600px) {
    min-width: 280px;
  }

  > * {
    margin-right: 1rem;
    margin-bottom: 1rem;
  }
`;

class MultiImageService extends React.Component {
  render() {
    const { title, images, scrollPosition } = this.props;
    return (
      <MultiImageServiceWrapper>
        <ServiceTitle>{title}</ServiceTitle>
        <ImageWrapper>
          {images.map((image) => (
            <LazyLoadComponent scrollPosition={scrollPosition}>
              <MultiServiceImageWrapper>
                <MultiServiceImage position={image.position} url={image.url} />
              </MultiServiceImageWrapper>
            </LazyLoadComponent>
          ))}
        </ImageWrapper>
      </MultiImageServiceWrapper>
    );
  }
}

class Services extends React.Component {
  render() {
    const { scrollPosition } = this.props;
    return (
      <Page>
        <Content>
          <Heading>
            <Title>Palvelut</Title>
            <ContentText>
              {" "}
              Kaivinholsti Oy on maanrakennuspalvelua tarjoava yritys, joka
              suorittaa haastavimmatkin kaivuutyöt alan vankalla kokemuksella ja
              ammattitaidolla. Toiminta-alueena on Padasjoki, Päijät-Häme ja
              tarvittaessa koko Suomi.
            </ContentText>
            <ContentText>
              {" "}
              Toimintaperiaate on tuottaa joustavaa ja asiakkaan tarpeita
              vastaavaa palvelua siistillä ja viimeistellyllä lopputuloksella.
            </ContentText>
          </Heading>

          {multiImageServices.map((mis) => (
            <MultiImageService
              title={mis.title}
              images={mis.images}
              scrollPosition={scrollPosition}
            />
          ))}
          <ServiceGrid>
            {services.map((service, i) => (
              <LazyLoadComponent scrollPosition={scrollPosition}>
                <ServiceCard key={i}>
                  <ServiceImage {...service.image} />
                  <ServiceTextWrap>
                    <ServiceText>{service.text}</ServiceText>
                  </ServiceTextWrap>
                </ServiceCard>
              </LazyLoadComponent>
            ))}
          </ServiceGrid>
        </Content>
      </Page>
    );
  }
}
export default trackWindowScroll(Services);



// WEBPACK FOOTER //
// ./src/Components/Services.js